export default __webpack_public_path__ + "static/media/11.d12dc24a.jpg";